import { Table, TableBody, TableFooter, TableHead } from '@mui/material';
import { IWorkInfoTableProps } from './WorkInfoTableModel';
import { WorkInfoTableRow } from './WorkInfoTableRow';
import { workInfoTableStyle } from './styled';

export const WorkInfoTable: React.FC<IWorkInfoTableProps> = ({
  headerRows = [],
  bodyRows = [],
  footerRows = []
}) => {
  return (
    <Table className='sx-small' sx={workInfoTableStyle}>
      <TableHead data-automation="tbl-header">
        {
          headerRows.map((row, i) => <WorkInfoTableRow row={row} key={i} dataAutomation="header-row" />)
        }
      </TableHead>
      <TableBody data-automation="tbl-body">
        {
          bodyRows.map((row, i) => (
            <WorkInfoTableRow
              row={{
                ...row,
                oddRow: i % 2 === 0
              }}
              key={i}
            />
          ))
        }
      </TableBody>
      <TableFooter data-automation="tbl-footer">
        {
          footerRows.map((row, i) => <WorkInfoTableRow row={row} key={i} dataAutomation="total-row" />)
        }
      </TableFooter>
    </Table>
  )
}